/* eslint-disable react/prop-types */
import React from 'react';

const AttributeOption = ({name, id, checked, handleSelection, children, available}) => {
    return (
        <>
            <input type="radio" id={id} name={name} checked={checked} onChange={handleSelection} />
            <label className={`radio ${!available ? 'not-available' : ''}`} htmlFor={id} tabIndex="0">
                {children}
            </label>
        </>
    );
};

export default AttributeOption;
